import React from 'react';
import { inject, observer } from 'mobx-react';
import { Form, Checkbox, Select, Input, Upload, Button } from 'antd';
import { toJS } from 'mobx';
import validate from './validate';
import util from '../../../util';

const {
  getAccessToken
} = util;

const {
  checkDouble,
  checkLen,
  normFile,
} = validate;
const CheckboxGroup = Checkbox.Group;
const FormItem = Form.Item;
const store = [
  'devStore'
]
@inject(...store)
@observer
class Main extends React.Component {
  static defaultProps = {
    prefixCls: 'dev-apply-form-step',
  }
  render() {
    const {
      prefixCls, form, formRequiredClass,
      devStore: { genre, genreModule },
    } = this.props;
    const formItemLayout = {
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
    };
    const { getFieldValue, getFieldProps, isFieldValidating, getFieldError } = form;
    return (
      <div className={`${prefixCls}`}>
        <FormItem
          label="适用行业："
          {...formItemLayout}
          className={formRequiredClass}
          hasFeedback={getFieldValue('s_trade') !== ""}
          help={isFieldValidating('s_trade') ? '校验中...' : (getFieldError('s_trade') || []).join(', ')}>
          <Select mode="multiple" {...getFieldProps("s_trade", {
            rules: [{ validator: checkLen }]
          })} optionFilterProp="search">
            {
              toJS(genre) && toJS(genre).map(v => (
                <Select.Option key={v.key} value={v.key} search={v.name}>{v.name}</Select.Option>
              ))
            }
          </Select>
        </FormItem>
        <FormItem
          label="相关模块："
          {...formItemLayout}
          className={formRequiredClass}
          hasFeedback={getFieldValue('s_type') !== ""}
          help={isFieldValidating('s_type') ? '校验中...' : (getFieldError('s_type') || []).join(', ')}>
          <Select mode="multiple" {...getFieldProps("s_type", {
            rules: [{ validator: checkLen }]
         })} optionFilterProp="search">
            {
              toJS(genreModule) && toJS(genreModule).map(v => (
                <Select.Option key={v.key} value={v.key} search={v.name}>{v.name}</Select.Option>
              ))
            }
          </Select>
        </FormItem>
        <FormItem
          label="浏览器兼容："
          {...formItemLayout}
          className={formRequiredClass}
          help={isFieldValidating('s_inter') ? '校验中...' : (getFieldError('s_inter') || []).join(', ')}>
          <CheckboxGroup
            {...getFieldProps('s_inter',
              {
			      		initialValue:['IE8', 'IE9', 'IE10','IE11','chrome'],
                rules: [{ validator: checkLen }]
              })}
            options={['IE8', 'IE9', 'IE10', 'IE11', 'chrome']}
          />
        </FormItem>
        <FormItem
          label="EC兼容："
          {...formItemLayout}
          className={formRequiredClass}
          help={isFieldValidating('s_ec') ? '校验中...' : (getFieldError('s_ec') || []).join(', ')}>
          <CheckboxGroup
            {...getFieldProps('s_ec',
              {
  			      	initialValue:[ 'EC7', 'EC8'],
                rules: [{ validator: checkLen }]
              })}
            options={['EC6', 'EC7', 'EC8']}
          />
        </FormItem>
        <FormItem
          label="EC兼容说明："
          {...formItemLayout}>
          <Input {...getFieldProps('s_ecdesc')} />
        </FormItem>
        <FormItem
          label="数据库支持："
          {...formItemLayout}
          className={formRequiredClass}
          help={isFieldValidating('s_database') ? '校验中...' : (getFieldError('s_database') || []).join(', ')}>
          <CheckboxGroup
            {...getFieldProps('s_database',
              {
			      		initialValue:['oracle', 'sqlserver'],
                rules: [{ validator: checkLen }]
              })}
            options={['oracle', 'sqlserver']}
          />
        </FormItem>
        <FormItem
          label="解决方案："
          {...formItemLayout}>
          <Upload action={window.server + "/v1/appfile"} data={{ type: "docfile", access_token: getAccessToken() }}
            onPreview={(file) => window.open(`${window.server}${file.url}`)}
            {...getFieldProps('docfile', {
              valuePropName: 'fileList',
		      		normalize: normFile,
            })}>
            <Button type="ghost" icon="upload">点击上传</Button>
          </Upload>
        </FormItem>
        <FormItem
          label="结算价格："
          {...formItemLayout}
          hasFeedback={getFieldValue('s_price') !== ""}
          help={isFieldValidating('') ? '校验中...' : (getFieldError('s_price') || []).join(', ')}>
          <Input
            {...getFieldProps('s_price', {
              rules: [{ required: true, validator: checkDouble }]
            }
            )} />
        </FormItem>
        <FormItem
          label="建议销售价格："
          {...formItemLayout}
          hasFeedback={getFieldValue('s_tuijianprice') !== ""}
          help={isFieldValidating('s_tuijianprice') ? '校验中...' : (getFieldError('s_tuijianprice') || []).join(', ')}>
          <Input
            {...getFieldProps('s_tuijianprice', {
              rules: [{ required: true, validator: checkDouble }]
            }
            )} />
        </FormItem>
      </div>
    )
  }
}

export default Main;


// WEBPACK FOOTER //
// ./src/components/dev/devApply/Form_step_1.js